import React, { useContext, useState, useReducer } from "react"
import {
  dataFetchReducer
} from "../../Utils/requestUtils"

import AuthContext from "../../../context/auth-context"
import CoafOccurrencesInbox from "./CoafOccurrencesInbox/CoafOccurrencesInbox"
import CoafBatchesInbox from "./CoafBatchesInbox/CoafBatchesInbox"
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import CoafOccurrenceDialog from "./CoafOccurrenceDialog"
import CoafBatchDialog from "./CoafBatchDialog"

import Button from "@material-ui/core/Button"
import AddIcon from "@material-ui/icons/Add"

function CoafCommunications() {
    const { t } = useTranslation()
    let history = useHistory()


    const [snackbarContent, setSnackbarContent] = useState(null)

    const [currentView, setCurrentView] = useState("occurrences-inbox")
    const [occurrenceDialogState, setOccurrenceDialogState] = useState({
        open: false,
        mode: "view",
        occurrence: null
    })
    const [batchDialogState, setBatchDialogState] = useState({
        open: false,
        mode: "view",
        batch: null
    })

    let roles = useContext(AuthContext).user_data.roles
    if (!(roles.includes('coaf_communication_manager'))) {
        history.push("")
    }

    const [occurrencePageState, occurrenceDispatchPageState] = useReducer(dataFetchReducer, {
        fetchedData: null,
        isLoading: true,
        isError: false,
    })

    const [batchPageState, batchDispatchPageState] = useReducer(dataFetchReducer, {
        fetchedData: null,
        isLoading: true,
        isError: false,
    })

    const [toggleOccurrences, setToggleOccurrences] = useState(false)
    const [toggleBatches, setToggleBatches] = useState(false)

    const refreshOccurrences = () => {
        setToggleOccurrences(!toggleOccurrences)
    }

    const refreshBatches = () => {
        setToggleBatches(!toggleBatches)
    }

    const handleCloseSnackbar = () => {
        setSnackbarContent(null)
    }

    const flexColumnStylesBatches = [
        "1 1 48px",
        "1 1 48px",
        "1 1 48px",
        "0 0 72px",
        "1 1 48px",
    ]

    const flexColumnStylesOccurrences = [
        "1 1 48px",
        "1 1 48px",
        "1 1 48px",
        "0 0 72px",
        "1 1 48px",
    ]

    const inboxViewComponents = {
        "occurrences-inbox": <CoafOccurrencesInbox
                               setOccurrenceDialogState={setOccurrenceDialogState}
                               setBatchDialogState={setBatchDialogState}
                               pageState={occurrencePageState}
                               dispatchPageState={occurrenceDispatchPageState}
                               flexColumnStyles={flexColumnStylesOccurrences}
                               setSnackbarContent={setSnackbarContent}
                               toggleOccurrences={toggleOccurrences}
                             />,
        "batches-inbox": <CoafBatchesInbox
                               setOccurrenceDialogState={setOccurrenceDialogState}
                               setBatchDialogState={setBatchDialogState}
                               pageState={batchPageState}
                               dispatchPageState={batchDispatchPageState}
                               flexColumnStyles={flexColumnStylesBatches}
                               setSnackbarContent={setSnackbarContent}
                               toggleBatches={toggleBatches}
                             />
    }

    const currentViewComponent = inboxViewComponents[currentView]

    const tabButtons = [
        {view: "occurrences-inbox",label: t("Ocorrências")},
        {view: "batches-inbox", label: t("Lotes")}
    ]

    const handleCreateClick = () => {
        if (currentView === "occurrences-inbox") {
            setOccurrenceDialogState({
                open: true,
                mode: "create",
                occurrence: { occurrence_key: null }
            })
        } else {
            setBatchDialogState({
                open: true,
                mode: "create",
                batch: { occurrence_batch_key: null }
            })
        }
    }

    return (
        <div style={{ width: "auto", paddingBottom: "30px" }}>
            <div style={{display:"flex"}}>
                <div >
                    <p className={["blueText", "titleSize"].join(" ")}>{t("COMUNICAÇÃO COM O COAF")}</p>
                </div>
            </div>

            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
                <div style={{ display: "flex", gap: "20px" }}>
                    {tabButtons.map((button) => {
                        const isSelected = (button.view === currentView)
                        const opacity = isSelected ? 1.0 : 0.6
                        return <div
                            key={button.view}
                            style={{ opacity: opacity, cursor: 'pointer' }}
                            className={["link", "subtitleSize", "bold"].join(" ")}
                            onClick={() => setCurrentView(button.view)}
                        > {button.label}
                        </div>
                    })}
                </div>

                <div>
                    <Button
                        variant="contained"
                        className={["button", "standard", "normalText", "normalMediumSize"].join(" ")}
                        startIcon={<AddIcon />}
                        onClick={handleCreateClick}
                        style={{ textTransform: 'none', fontWeight: 'bold', borderRadius: '18px' }}
                    >
                        {currentView === "occurrences-inbox" ? t("Criar Ocorrência") : t("Criar Lote")}
                    </Button>
                </div>
           </div>

           {currentViewComponent? currentViewComponent : <div></div>}
           {occurrenceDialogState.open && (
                <CoafOccurrenceDialog
                    occurrence={occurrenceDialogState.occurrence}
                    occurrenceDialogState={occurrenceDialogState}
                    setOccurrenceDialogState={setOccurrenceDialogState}
                    refreshList={refreshOccurrences}
                    setSnackbarContent={setSnackbarContent}
                />
            )}
            {batchDialogState.open && (
                <CoafBatchDialog
                    batch={batchDialogState.batch}
                    batchDialogState={batchDialogState}
                    setBatchDialogState={setBatchDialogState}
                    setOccurrenceDialogState={setOccurrenceDialogState}
                    refreshList={refreshBatches}
                    setSnackbarContent={setSnackbarContent}
                />
            )}
            {snackbarContent && (
                <Snackbar open={!!snackbarContent} autoHideDuration={10000} onClose={handleCloseSnackbar} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}>
                    <Alert
                        onClose={handleCloseSnackbar}
                        severity={snackbarContent?.type}
                        variant="filled"
                    >
                        {t(snackbarContent?.message || "")}
                    </Alert>
                </Snackbar>
            )}
        </div>
    )
}

export default CoafCommunications